module.exports = __webpack_public_path__ + "static/media/educators-01.10fe53fc.jpg";